import HttpClient from "./http-client";
import { getApiUrl, getCurrentLanguageId } from "./common";

interface Resource {
    Key: string;
    Value: string;
}

export default class StringLocalizer{
    private resources: Resource[];

    private defaultFallbackResources: Resource[] = [
        {Key: "Close", Value: "Close" },
        {Key: "Warning", Value: "Warning" },
        {Key: "AjaxCallFailGeneralMessage", Value: "We are sorry, action failed. Please try again later." },
     ]

    constructor(){
    }

    public async init(): Promise<void>{
        await this.loadResources();
    }

    public get(name: string){
        const resource = this.resources?.find(x => x.Key === name) ?? this.defaultFallbackResources?.find(x => x.Key === name);
        return resource ? resource.Value : `Missing.${name}`;
    }
    
    private async loadResources(): Promise<void> {
        const langId = getCurrentLanguageId();
        const response = await new HttpClient().fetch(`${getApiUrl()}/clientresource?t=${getCurrentLanguageId()}`,  {
            headers: {
                'Current-Language-Id': langId
            }
        }, (_) => {});

        if(response && response.ok) {
            this.resources = await response.json() as Resource[];
        }
    }
}
